export default __webpack_public_path__ + "locales/ko-KR/VersionHistory.json?hash=17a884f2c23be0b849d227c3df1fc59a";